import { useState } from "react";
import { emptyVinoForm, vinoToForm } from "../domain/vinosForm";

export function useVinoForm() {
    const [formVisible, setFormVisible] = useState(false);
    const [editingVino, setEditingVino] = useState(null);
    const [formData, setFormData] = useState(emptyVinoForm());

    const openCreate = () => {
        setEditingVino(null);
        setFormData(emptyVinoForm());
        setFormVisible(true);
    };

    const openEdit = (vino) => {
        setEditingVino(vino);
        setFormData(vinoToForm(vino));
        setFormVisible(true);
    };

    const close = () => setFormVisible(false);

    const reset = () => {
        setEditingVino(null);
        setFormData(emptyVinoForm());
    };

    return {
        formVisible, setFormVisible,
        editingVino,
        formData, setFormData,
        openCreate, openEdit, close, reset,
    };
}
